import { Button, Flex } from "@radix-ui/themes";
import React, { useCallback, useMemo } from "react";

export interface PaginationProps {
  total: number;
  count: number;
  activeIndex: number;
  onChangeIndex: (index: number) => any;
  classNameContainer?: string;
}

export default function Pagination({
  total,
  count,
  activeIndex,
  onChangeIndex,
  classNameContainer,
}: PaginationProps) {
  const pages = Math.ceil(total / count);

  const changeIndex = useCallback((index: number) => {
    if (index >= 0 && index < pages) onChangeIndex(index);
  }, [pages, activeIndex, onChangeIndex]);

  // Определяем диапазон видимых страниц
  const getVisiblePages = useMemo(() => {
      const visible: number[] = [];
    const maxVisible = 5;

    const start = Math.max(0, Math.min(activeIndex - 2, pages - maxVisible));
    const end = Math.min(pages - 1, start + maxVisible - 1);

    if (start > 0) {
      visible.push(0);
      if (start > 1) visible.push(-1);
    }

    for (let i = start; i <= end; i++) visible.push(i);

    if (end < pages - 1) {
      if (end < pages - 2) visible.push(-1);
      visible.push(pages - 1);
    }

    return visible;
  }, [pages, activeIndex]);


  return (
    <Flex gap="1" className={classNameContainer} wrap="wrap">
      {getVisiblePages.map((page, i) =>
        page === -1 ? (
          <Button key={`dots-${i}`} variant="ghost" disabled>
            ...
          </Button>
        ) : (
          <Button
            key={page}
            onClick={() => changeIndex(page)}
            variant={activeIndex === page ? "solid" : "outline"}
          >
            {page + 1}
          </Button>
        )
      )}
    </Flex>
  );
}